module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-input"
  }, [(_vm.mask) ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.customMasks),
      expression: "customMasks"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "id": _vm.id,
      "maxlength": _vm.maxlength,
      "required": _vm.isRequired,
      "disabled": _vm.isDisabled,
      "type": _vm.type,
      "masked": "true"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": _vm.onChange
    }
  }) : _c('input', {
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "id": _vm.id,
      "required": _vm.isRequired,
      "disabled": _vm.isDisabled,
      "maxlength": _vm.maxlength,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2384452"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/atomicComponents/Input/Input.vue.html
// module id = PRHu
// module chunks = 2